import Api from "./api"

export default {
	request(data) {
		return Api().post("/payment/request", data)
	},

	query(data) {
		return Api().post("/payment/query", data)
	},

	flutterwaveRequest(data) {
		return Api().post("/payment/flutterwave/request", data)
	},

	flutterwaveCallback(data) {
		return Api().post("/payment/flutterwave/callback", data)
	},

	pesapalRequest(data) {
		return Api().post("/payment/pesapal/request", data)
	}
}